import ReportKeyTakeaways from './reportKeyTakeaways'
export default ReportKeyTakeaways
